import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";

export const CTABanner = () => {
  return (
    <section
      data-testid="cta-banner"
      className="py-14 sm:py-18 bg-brand-orange relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[linear-gradient(45deg,#000000_25%,transparent_25%,transparent_75%,#000000_75%,#000000),linear-gradient(45deg,#000000_25%,transparent_25%,transparent_75%,#000000_75%,#000000)] bg-[length:60px_60px] bg-[position:0_0,30px_30px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
          <div className="text-center lg:text-left">
            <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl font-semibold tracking-tight uppercase text-white">
              Ready to Transform Your Home?
            </h2>
            <p className="text-sm sm:text-base text-white/80 mt-2 max-w-lg">
              Get a free estimate for your painting project. No obligation, just honest pricing.
            </p>
          </div>

          <Link to="/quote" className="w-full sm:w-auto flex-shrink-0">
            <Button
              data-testid="cta-quote-btn"
              size="lg"
              className="w-full sm:w-auto bg-brand-navy text-white font-heading font-semibold uppercase tracking-wide hover:bg-brand-navy/90 hover:scale-[1.03] active:scale-[0.98] transition-all duration-300 shadow-lg h-12 px-7"
            >
              Get Free Estimate
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
